export const environment = {
  production: true,
  ApiURL: "https://api.lema.dk/api",
  AppName: "LEMA",
  authTokenKey: "lemaTokenKey",
  appVersion: require("../../package.json").version,
};
